import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import * as colors from '../../common/styles/colors';
import { ButtonPrimary } from '../../common/components';

type DeleteScheduledReportModalProps = {
  show: boolean;
  onYes: Function;
  onNo: Function;
  bodyText?: string;
};

const defaultProps = {
  show: true,
};

const DeleteScheduledReportModalWrapper = styled.div`
  .modal-title {
    color: ${colors.hydroBlue};
  }
`;

export const DeleteScheduledReportModal = (props: DeleteScheduledReportModalProps) => {
  const titleText = "Delete Scheduled Report";

  return (
    <Modal animation={false} className={'custom-modal'} show={props.show} backdrop='static' centered>
      <DeleteScheduledReportModalWrapper>
        <Modal.Header className='pb-4' style={{ justifyContent: 'center', textAlign: 'center' }}>
          <Modal.Title>{titleText}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center', textAlign: 'start' }}>
          <p className='px-5'>{props.bodyText}</p>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <div className='d-flex justify-content-end'>
            <ButtonPrimary onClick={() => props.onYes()} className={'m-0 ml-2'} title={'Yes'} route='#' />
            <ButtonPrimary onClick={() => props.onNo()} className={'m-0 ml-3'} title={'No'} route='#' />
          </div>
        </Modal.Footer>
      </DeleteScheduledReportModalWrapper>
    </Modal>
  );
};

DeleteScheduledReportModal.defaultProps = defaultProps;